import React from 'react';
import './index.css';
import Parser from './parser';

function App() {
  return (
      <Parser/>
  );
}

export default App;
